import React, { useState } from 'react'

function QandA({ question, children }) {
  const [show, setShow] = useState(false)

  const toggle = () => {
    setShow(!show)
  }

  return (
    <div className="row">
      <div className="col-sm-12 faq-qna">
        <p className="faq-question" onClick={() => toggle()}>
          {question}
        </p>
        {show && <p className="faq-answer">{children}</p>}
      </div>
    </div>
  )
}

export default QandA
